import { Navigate } from 'react-router-dom';
import { authController } from '../controllers/authController';

const ProtectedRoute = ({ children }) => {
  const isAuthenticated = authController.isAuthenticated();
  
  if (!isAuthenticated) {
    // Redirect to home page if not authenticated
    return <Navigate to="/" replace />;
  }
  
  return children;
};

export default ProtectedRoute;